import { ArrowDown, Sparkles } from "lucide-react";
import { useLang, STR, LANGS } from "@/i18n";

export const scrollTo = (href) => (e) => {
  e.preventDefault();
  if (window.__lenis) {
    window.__lenis.scrollTo(href, { offset: -90 });
  } else {
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  }
};

export default function Header() {
  const { lang, setLang } = useLang();
  const t = STR[lang];
  const links = [
    { label: t.nav_manifesto, href: "#manifesto", id: "nav-link-manifesto" },
    { label: t.nav_vip, href: "#vip", id: "nav-link-vip" },
    { label: t.nav_faq, href: "#faq", id: "nav-link-faq" },
  ];

  return (
    <header
      data-testid="header-navbar"
      className="fixed left-1/2 top-4 z-50 w-[94%] max-w-6xl -translate-x-1/2"
    >
      <div className="relative overflow-hidden rounded-[28px] bg-[#10072a]/70 px-3 py-3 shadow-[0_18px_60px_-34px_rgba(0,0,0,0.9)] backdrop-blur-2xl sm:px-4">
        <div className="pointer-events-none absolute inset-x-5 top-0 h-px bg-[linear-gradient(90deg,transparent,rgba(255,255,255,0.34),transparent)]" />
        <div className="flex items-center justify-between gap-3">
          <a
            href="#"
            data-testid="header-logo"
            onClick={(e) => e.preventDefault()}
            className="group flex shrink-0 items-center gap-3"
          >
            <span className="relative grid h-11 w-11 place-items-center overflow-hidden rounded-[18px] bg-[linear-gradient(145deg,#ffcf55,#ff7a1a_48%,#7631ff)] p-[2px] transition duration-300 group-hover:-rotate-3 group-hover:scale-105">
              <span className="absolute inset-0 bg-[radial-gradient(circle_at_30%_18%,rgba(255,255,255,0.55),transparent_32%)]" />
              <img src="/logo.png" alt="DUELO" className="relative h-full w-full rounded-[16px] object-cover" />
            </span>
            <span className="hidden sm:block">
              <span className="font-display block text-lg font-black leading-none tracking-[0.14em] text-white">DUELO</span>
            </span>
          </a>

          <nav className="hidden items-center gap-1 md:flex">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={scrollTo(l.href)}
                data-testid={l.id}
                className="rounded-full px-4 py-2 text-[11px] font-extrabold uppercase tracking-[0.16em] text-white/52 transition duration-300 hover:bg-white/10 hover:text-white"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex shrink-0 items-center gap-2">
            <div data-testid="lang-switcher" className="hidden items-center gap-1 rounded-full bg-white/10 p-1 sm:flex">
              {LANGS.map((l) => (
                <button
                  key={l.id}
                  onClick={() => setLang(l.id)}
                  data-testid={"lang-btn-" + l.id}
                  aria-pressed={lang === l.id}
                  className={
                    "rounded-full px-2.5 py-1.5 text-[10px] font-black uppercase tracking-wide transition duration-300 " +
                    (lang === l.id
                      ? "bg-[#fff7ef] text-[#190735] shadow-[0_10px_22px_-16px_rgba(255,191,61,0.8)]"
                      : "text-white/48 hover:text-white")
                  }
                >
                  {l.label}
                </button>
              ))}
            </div>

            <button
              onClick={scrollTo("#download")}
              data-testid="header-download-btn"
              className="game-sheen flex items-center gap-2 overflow-hidden rounded-[20px] bg-[linear-gradient(135deg,#ffcf55,#ff8a1f)] px-4 py-3 text-sm font-black text-[#1a0a02] transition duration-300 hover:-translate-y-0.5 active:translate-y-0 active:scale-[0.98] sm:px-5"
            >
              <Sparkles className="hidden h-4 w-4 sm:block" strokeWidth={2.3} />
              <span className="hidden sm:inline">{t.download_app}</span>
              <span className="sm:hidden">App</span>
              <ArrowDown className="h-4 w-4" strokeWidth={2.6} />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
